import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { AlignRight } from 'lucide-react';
import { Link as RouterLink } from 'react-router-dom';

const Navbar = () => {
  const [isTop, setIsTop] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsTop(window.scrollY === 0);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const buttonVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.7, delay: 0.3, ease: 'easeOut' },
    },
  };

  const navItems = [
    { label: 'Pricing', path: '/plan-and-pricing' },
    { label: 'Features', path: '/features' },
  ];

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          backgroundColor: isTop ? 'transparent' : 'white',
          boxShadow: isTop ? 'none' : '0 2px 4px rgba(0,0,0,0.1)',
          transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
          px: { xs: 3, md: 3 },
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          {/* Logo */}
          <Box
            component={motion.div}
            variants={buttonVariants}
            initial="hidden"
            animate="visible"
          >
            <Typography
              variant="h4"
              component={RouterLink} 
              to="/"                 
              sx={{
                                    fontWeight: 800,
                                    fontSize: '1.5rem',
                                    lineHeight: 1.1,
                                    letterSpacing: '-0.03em',
                color: isTop ? '#1D4ED8' : '#1D4ED8',
                fontFamily: 'unset',
                textDecoration: 'none', 
                cursor: 'pointer'       
              }}
            >
              BIZSTOR
            </Typography>
          </Box>

          {isMobile ? (
            // Burger Icon on Mobile
            <IconButton onClick={() => setDrawerOpen(true)}>
              <AlignRight color={isTop ? 'black' : '#223C4E'} />
            </IconButton>
          ) : (
            // Desktop Navigation
            <Box
              component={motion.div}
              variants={buttonVariants}
              initial="hidden"
              animate="visible"
              sx={{ display: 'flex', alignItems: 'center', gap: 3, }}
            >
              {navItems.map((item) => (
                <Button
                  key={item.label}
                  onClick={() => navigate(item.path)}
                  sx={{
                    backgroundColor: 'transparent',
                    color: isTop ? '#000000' : '#000000',
                    textTransform: 'none',
                    '&:hover': { backgroundColor: 'transparent' },
                    fontWeight:'bold'
                  }}
                >
                  {item.label}
                </Button>
              ))}
              <Button
                onClick={() => navigate('/login')}
                sx={{
                  backgroundColor: 'transparent',
                  color: isTop ? '#000000' : '#223C4E',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'transparent' },
                  width: '85px',
                  fontWeight:'bold'
                }}
              >
                Login
              </Button>
              {/**<Button
                onClick={() => navigate('/register')}
                sx={{
                  backgroundColor: 'rgba(245, 245, 245, 1)',
                  color: '#223C4E',
                  borderRadius: '25px',
                  textTransform: 'none',
                  width: '95px',
                  fontweight:'bold',
                  '&:hover': { backgroundColor: '#f1f1f1ff' },
                }}
              >
                Sign up
              </Button>*/}
            </Box>
          )}
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="top"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            height: '60%',
            borderBottomLeftRadius: '20px',
            borderBottomRightRadius: '20px',
            backgroundColor: 'white',
            p: 2,
          },
        }}
      >
        {/* Close Icon */}
        <Box display="flex" justifyContent="flex-end">
          <IconButton onClick={() => setDrawerOpen(false)}>
            <X />
          </IconButton>
        </Box>

        <List>
          {navItems.map((item) => (
            <ListItem button key={item.label} onClick={() => { setDrawerOpen(false); navigate(item.path); }}>
              <ListItemText primary={item.label} primaryTypographyProps={{ fontWeight: 600, fontSize: '1.1rem' }} />
            </ListItem>
          ))}
        </List>

        <Box mt="auto" textAlign="center" pt={4}>
          <Button
            variant="text"
            fullWidth
            onClick={() => { setDrawerOpen(false); navigate('/login'); }}
            sx={{ color: '#223C4E', textTransform: 'none', mb: 1 }}
          >
            Login
          </Button>
          <Button
            variant="contained"
            fullWidth
            onClick={() => { setDrawerOpen(false); navigate('/register'); }}
            sx={{
              borderRadius: '25px',
              textTransform: 'none',
              backgroundColor: '#223C4E',
              color: 'white',
              '&:hover': { backgroundColor: '#1a293b' },
            }}
          >
            Sign up
          </Button>
        </Box>
      </Drawer>
    </>
  );
};

export default Navbar;
